import { PureComponent } from 'react'
import getCSRFToken from '../../utils/csrf'
import HiddenInput from './hidden_input'

export default class AuthenticityToken extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      authenticityToken: getCSRFToken(),
    }
  }

  render() {
    const { authenticityToken } = this.state
    return <HiddenInput name="authenticity_token" value={authenticityToken} />
  }
}
